import React from "react";
import { Field, Textarea, Text } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

import EditableStringList from "../common/EditableStringList";
import "../../CSS/IaAgent.css";

export default function GreetingTab({ agentData, updateField }) {
  const { t } = useTranslation();
  const greeting = agentData.behaviorRules?.greeting || {};
  const general = agentData.behaviorRules?.general || [];
  const personality = agentData.agentPersonality || {};

  // Live preview of the greeting after placeholder substitution
  const preview = (greeting.format || "")
    .replace(/\{name\}/g, personality.name || "{name}")
    .replace(/\{role\}/g, personality.role || "{role}")
    .replace(/\{company\}/g, personality.company || "{company}");

  return (
    <div className="ia-agent-tab">
      <Field
        label={t("GREETING_FORMAT")}
        className="field-style"
        required
        hint={t("GREETING_PLACEHOLDER_HINT")}
      >
        <Textarea
          value={greeting.format || ""}
          onChange={(_, d) => updateField("behaviorRules.greeting.format", d.value)}
          placeholder={t("GREETING_FORMAT_PLACEHOLDER")}
          resize="vertical"
          rows={3}
        />
      </Field>

      <div
        style={{
          backgroundColor: "#f5f5f5",
          padding: 12,
          borderRadius: 6,
          marginBottom: 16,
          borderLeft: "4px solid #0078d4",
        }}
      >
        <Text size={200} weight="semibold" style={{ display: "block", marginBottom: 4 }}>
          {t("GREETING_PREVIEW")}
        </Text>
        <Text size={300} style={{ fontStyle: "italic" }}>
          {preview || t("GREETING_PREVIEW_EMPTY")}
        </Text>
      </div>

      <EditableStringList
        label={t("GENERAL_BEHAVIOR_RULES")}
        value={general}
        onChange={(list) => updateField("behaviorRules.general", list)}
        placeholder={t("GENERAL_BEHAVIOR_RULES_PLACEHOLDER")}
      />

      <Text className="ia-agent-hint">{t("GREETING_TAB_HINT")}</Text>
    </div>
  );
}
